<template>
    <div class="alert">
        <div class="alert-head">
            <div class="alert-icon"><i class="fas fa-exclamation"></i></div>
            <div class="alert-title title">{{ title }}</div>
        </div>
        <slot></slot>
        <div class="alert-text title" v-html="message"></div>

        <div class="alert-options">
            <button class="option" :class="{ 'is-selected': selected === 'periodRent' }"
                @click="selectOption('periodRent')" type="button">
                <span class="radio" aria-hidden="true">
                    <span class="dot" />
                </span>
                <span class="option-body">
                    <span class="option-label">PERÍODO ATUAL</span>
                    <span class="option-dates">{{ periodRent }}</span>
                </span>
            </button>

            <button class="option" :class="{ 'is-selected': selected === 'newPeriod' }"
                @click="selectOption('newPeriod')" type="button">
                <span class="radio" aria-hidden="true">
                    <span class="dot" />
                </span>
                <span class="option-body">
                    <span class="option-label">NOVO PERÍODO</span>
                    <span class="option-dates">{{ periodRentReturn }}</span>
                </span>
            </button>
        </div>
        <div v-if="selected == 'newPeriod'" class="div-warning">
            <Alert type="warning">
                <span>
                    Ao selecionar esta opção, o <b>PERÍODO DE LOCAÇÃO</b> será <b>ATUALIZADO</b>. Certifique-se antes de
                    confirmar! </span>
            </Alert>
        </div>

        <div class="actions">
            <button class="btn-primary" @click="confirm" type="button">
                Continuar
            </button>
        </div>
    </div>
</template>

<script>

import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

export default {
    name: "WarningMoviment",
    components: {
        Alert
    },
    props: {
        title: { type: String, default: "Attention" },
        message: {
            type: String,
        },
        periodRent: { type: String, required: true },
        periodRentReturn: { type: String, required: true }
    },
    data() {
        return { selected: "periodRent" }
    },
    methods: {
        selectOption(option) {
            this.selected = option
            this.$emit("select", option)
        },
        confirm() {
            this.$emit("confirm", this.selected)
        }
    }
}
</script>

<style scoped>
.alert {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 14px;
    padding: 20px;
    margin: 16px auto;
    text-align: center;
}

.alert-head {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.alert-icon {
    background: #fff3d6;
    color: #f59e0b;
    border-radius: 10px;
    width: 40px;
    height: 40px;
    display: grid;
    place-items: center;
}

.alert-title {
    font-weight: 700;
    font-size: 20px;
}

.alert-text {
    margin: 8px auto 18px;
    font-size: 15px;
    color: #333;
    max-width: 680px;
}

.alert-options {
    display: grid;
    gap: 12px;
    padding: 6px 8px;
}

.option {
    width: 100%;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    border-radius: 999px;
    padding: 12px 16px;
    display: grid;
    grid-template-columns: 24px 1fr;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: background .15s ease, box-shadow .15s ease, border-color .15s ease;
    text-align: left;
}

.option:hover {
    background: #f3f4f6;
}

.option.is-selected {
    background: #e0e7ff;
    border-color: #007BFF;
    color: #007BFF;
}

.radio {
    width: 18px;
    height: 18px;
    border: 2px solid #9ca3af;
    border-radius: 999px;
    display: grid;
    place-items: center;
    transition: border-color .15s ease, background .15s ease;
    background: #fff;
}

.option.is-selected .radio {
    border-color: #1d4ed8;
    background: #fff;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: transparent;
    transition: background .15s ease;
}

.option.is-selected .dot {
    background: #1d4ed8;
}

.option-body {
    display: grid;
}

.option-label {
    font-weight: 700;
    letter-spacing: .06em;
    font-size: 12px;
    color: #6b7280;
}

.option-dates {
    font-size: 16px;
    color: #222;
}

.actions {
    margin-top: 16px;
    display: flex;
    justify-content: center;
}

.btn-primary {
    background: #1d4ed8;
    color: #fff;
    border: none;
    border-radius: 50px;
    padding: 8px 18px;
    font-weight: 500;
    letter-spacing: 2px;
    cursor: pointer;
}

.btn-primary:hover {
    filter: brightness(1.05);
}

.btn-primary:active {
    transform: translateY(1px);
}

.div-warning {
    margin: 10px 50px 20px 50px;
}


@media (max-width: 560px) {
    .option-dates {
        font-size: 14px;
    }
}
</style>
